import { render } from "./SendTicketView.vue?vue&type=template&id=161c38d6&scoped=true"
import script from "./SendTicketView.vue?vue&type=script&lang=js"
export * from "./SendTicketView.vue?vue&type=script&lang=js"

import "./SendTicketView.vue?vue&type=style&index=0&id=161c38d6&scoped=true&lang=css"

import exportComponent from "/home/runner/work/tribuk-ui/tribuk-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-161c38d6"]])

export default __exports__